import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjausehdotusPalauteYllapitoOp, KirjausehdotusPalauteYllapitoPyynto, KirjausehdotusPalauteYllapitoPyyntoMap } from '../../_jaettu-lemonator/model/llm-kirjausehdotus-palaute'

export function callLlmKirjausehdotusPalaute<K extends KirjausehdotusPalauteYllapitoOp>(
  firebase: FirebaseLemonator,
  op: K,
  payload: KirjausehdotusPalauteYllapitoPyyntoMap[K]['req'],
): Promise<KirjausehdotusPalauteYllapitoPyyntoMap[K]['resp']> {
  return firebase.functionsCall<KirjausehdotusPalauteYllapitoPyynto, KirjausehdotusPalauteYllapitoPyyntoMap[K]['resp']>('llmKirjausehdotusPalauteYllapito', { op, payload } as KirjausehdotusPalauteYllapitoPyynto)
}
